import { RESERVATION_DETAIL } from "../routes/Paths";
// import {
//   getParametersFromLocalStorage
// } from "../helpers/commonHelper";

//   const settings = getParametersFromLocalStorage("settings");
//   const paymentPageTimer = settings?.find(
//     (setting) => setting.parameterName === "paymentPageTimerInSeconds"
//   );
//     const KeyEncodingPageTimer = settings?.find(
//     (setting) => setting.parameterName === "KeyEncodingPageTimerInSeconds"
//   );
//       const CommonPageTimer = settings?.find(
//     (setting) => setting.parameterName === "CommonPageTimerInSeconds"
//   );
//         const ThankyouPageTimer = settings?.find(
//     (setting) => setting.parameterName === "ThankYouPageTimerInSeconds"
//   );
  
// export const timerConstantValue = CommonPageTimer;
// export const paymentTimerConstantValue = paymentPageTimer;
// export const keyencodingTimerConstantValue = KeyEncodingPageTimer;
// //export const thankyouPageTimerValue = "60";
// export const thankyouPageTimerValue = ThankyouPageTimer;//changed to 30

//#region 
export const STEP_MASTER_ENUM = {
 
    //CHECKIN_PAGE:"CH01",
    //CHECKOUT_PAGE: "CH02",
    //KEY_PAGE: "KY01",
    //DOCUMENT_SCAN_PAGE: "DS01",
    //CONFIRMATION_NUMBER_SEARCH_PAGE: "CS01",
    //QR_CODE_PAGE: "QR01",
    HOME_PAGE: "SKI01",
    RESERVATION_SEARCH_PAGE: "SKI02",
    SCAN_DOCUMENT_PAGE: "SKI03",
    FACEVERIFICATION_PAGE: "SKI04",
    MANUAL_AUTHENTICATION_PAGE: "SKI05",
    UPSELL_PAGE: "SKI06",
    REGISTRATION_CARD_PAGE: "SKI07",
    PAYMENT_PAGE: "SKI08",
    KEY_PAGE: "SKI09",
    CHECKIN_THANKYOU_PAGE:"SKI10",
    
    FOLIO_PAGE: "SKO02",
    EMAIL_PAGE: "SKO03",
    CHECKOUT_THANKYOU_PAGE:"SKO04",
    CHECKOUT_RESERVATION_SEARCH_PAGE:"SKO01",
    CHECKOUT_PAYMENT_PAGE:"SKO05",

    KEY_SEARCH: "SKK01",
    KEY_ENCODE_PAGE: "SKK02",
    KEY_FACEVERIFICATION_PAGE_PAGE: "SKK03",
    KEY_THANKYOU_PAGE: "SKK04",
  } 

  export const MODULE_MASTER_ENUM = {
    CHECKIN:"CH01",
    CHECKOUT: "CH02",
    KEY: "KY01",
    DOCUMENT_SCAN: "DS01",
    CONFIRMATION_NUMBER_SEARCH: "CS01",
    QR_CODE: "QR01",
  } 


  export const CONFIG_MASTER_ENUM = {
    FOLIO_VIEW: "SSF",
    SIGNATURE_FOLIO_REQUIRED:"SFR",
    FOLIO_CHECKBOXES_REQUIRED:"FCBR",
    EMAIL_REQUIRED:"ESR",
    PRINT_REQUIRED:"PSR",
    ADULTCOUNT_CHNAGE_REQUIRED:"ACO",
    ADULTCOUNT_CHANGE_FRONTDESK:"ACF",
    CHILDCOUNT_CHANGE_REQUIRED:"CCO",
    SOFTCHILDCOUNT_CHANGE_REQUIRED:"SCCO",
    RESERVATION_INFO:"RSF",
    SETTLE_BY_PMS:"SPMS",
    SMS_REQUIRED:"SSR",
    WHATSAPP_REQUIRED:"WSR",
    PRINT_REQUIRED:"PSR",
    TOGGLE_PAY:"PGL",
    LANGUAGE: "LSR",
    QUEUEROOM: "QRM",
    FACE_MATCH:"FCM",
    FIRSTNAME_FILTER:"FNF",
    AUTO_EMAIL:"AEE",
    DISABLE_FOOTER:"DF",
    CHANGE_HOMEPAGE:"CH",//ss,
    EARLY_CHECKIN_QUEUE:"EQRM",
    SKIP_IMAGE:"SKP",
    DOCUMENT_CONFIRMATION_REQUIRED:"DCR",
    CHECKOUT_PAYMENT_CARD_CONFIRMATION_REQUIRED:"PCR",
    HIDE_CONSENT_IMAGE:"HCI",
    ENABLE_SKIP_UPGRADE:"ESU",
    SKIP_ACCOMPANY_DOCUMENT: "SAD",
    SKIP_FULL_DOCUMENT_VALIDATION: "SDV",
    PAYMENT_HIDE_CONSENT_IMAGE:"SPCI"
  } 
  export const STEP_CONFIG_ENUM = {
    CONFIRMATION_CHKDT: "CCD",
    LASTNAME_CHKDT: "LCD",
    LASTNAME_CONFIRMATION: "LCN",
    LASTNAME_ROOMNUMBER: "LRN",
    QR_CODE: "QR",
    LASTNAME_ROOMNUMBER_DATE: "LRND",
  } 

  export const SESSION_ENUM = {
    PRECHECKIN: "preCheckin",
    EARLY_CHECKIN: "earlyQueue",
  } 

  export const SOURCE_PAGES = {
    RESERVATION_LIST: 'ReservationList',
    HOME_PAGE: 'HomePage',
  };

  export const SUB_STEP = {
    CheckinStarted: 'CheckinStarted',
    DocumentScanCompleted: 'DocumentScanCompleted',
    FaceVerificationCompleted: 'FaceVerificationCompleted',
  }
//#endregion